import { ReportCollectedItemsMode } from '~globals/types/enums';
import { RouteReportCollectedItemsResponse } from '~services/route/report/types';

import { DashboardVariantV2CarrierContentCollectTrackingPanelId } from './types';

export const getReportCollectedItemsModeByTabId = (
  tabId: DashboardVariantV2CarrierContentCollectTrackingPanelId,
): ReportCollectedItemsMode => {
  if (tabId === 'companies') return ReportCollectedItemsMode.Companies;

  if (tabId === 'zones') return ReportCollectedItemsMode.Zones;

  return ReportCollectedItemsMode.Drivers;
};

export const sortTrackingDataResponse = (
  trackingDataResponse: RouteReportCollectedItemsResponse,
): RouteReportCollectedItemsResponse => {
  trackingDataResponse.collectedItemsByDriver?.sort(
    (currentItem, nextItem) =>
      nextItem.totalCollected - currentItem.totalCollected,
  );

  trackingDataResponse.collectedItemsByZone?.sort(
    (currentItem, nextItem) =>
      nextItem.totalCollected - currentItem.totalCollected,
  );

  trackingDataResponse.collectedItemsByCompany?.sort(
    (currentItem, nextItem) =>
      nextItem.totalCollected - currentItem.totalCollected,
  );

  return trackingDataResponse;
};
